const GlobalStockChart = require('okCharts/GlobalStockChart');

module.exports = GlobalStockChart;
